import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { cellStyle, tableInRowStyle } from "./OrderSummaryTableStyles";
import React from "react";
import { stripTrailingZeros } from "../../../../../utils/decimal";

export const SummaryTotalTable = (totals) => (
  <Table sx={tableInRowStyle}>
    <TableBody>
      {
        totals.map((total) => (
          <TableRow>
            <TableCell sx={{...cellStyle, minWidth: "50px"}}>
              {total.orderingUnitQuantity || ''}
            </TableCell>
            <TableCell sx={{...cellStyle, minWidth: "50px"}}>
              {stripTrailingZeros(total.orderQuantityTotal.toString()) + total.orderingUnitName}
            </TableCell>
          </TableRow>
        ))
      }
    </TableBody>
  </Table>
);

